import script from "./NewDisconnectionRequestModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NewDisconnectionRequestModal.vue?vue&type=script&setup=true&lang=js"

import "./NewDisconnectionRequestModal.vue?vue&type=style&index=0&id=143788b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-143788b0"]])

export default __exports__